import React, { FC, ReactNode } from "react";

import { Loading } from "../ui";

import styles from "./index.module.css";

type LoadingContainerProps = {
  children?: ReactNode;
};

const LoadingContainer: FC<LoadingContainerProps> = ({ children }) => {
  return <div className={styles.container}>{children || <Loading />}</div>;
};

export default LoadingContainer;
